import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from 'components/Firebase';
import * as ROUTES from 'constants/routes';
import * as ROLES from 'constants/roles';
import { Button, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import image from "assets/img/hemp-leaves.jpg";

const SignUpPage = () => (
  <div style={{ paddingTop: '50px', textAlign: 'center' }}>
    <Typography variant='h1' style={{ paddingBottom: '50px' }}>SignUp</Typography>
    <SignUpForm />
  </div>
);

const INITIAL_STATE = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  address: '',
  company: '',
  licenseNumber: '',
  licenseType: '',
  xplotLocation: '',
  yplotLocation: '',
  comments: '',
  isAdmin: '',
  isSeedProducer: '',
  isFarmer: '',
  isProcessor: '',
  isRegulator: '',
  error: '',
  publicKey: '',
  privateKey: '',
  // signer: ''
};

const ERROR_CODE_ACCOUNT_EXISTS = 'auth/email-already-in-use';
const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with this E-Mail address already exists.
  Try to login with this account instead. If you think the
  account is already used from one of the social logins, try
  to sign in with one of them. Afterward, associate your accounts
  on your personal account page.
`;

class SignUpFormBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    //===KEY-PAIR GENERATION===//
    console.log("Submitted");
    const url = 'http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:8008'
    console.log("We here");
    const { createContext, CryptoFactory } = require('sawtooth-sdk/signing');
    // const { protobuf } = require('sawtooth-sdk');
    console.log(createContext);
    const context = createContext('secp256k1');
    console.log(CryptoFactory);
    const priv = context.newRandomPrivateKey();
    const x_signer = new CryptoFactory(context).newSigner(priv);

    const pub = x_signer.getPublicKey().asHex();
    console.log("Key pair generated:");
    console.log("Public Key: " + pub);
    console.log(typeof (pub))
    console.log("Private Key: " + priv.asHex());
    console.log(x_signer);

    this.setState({
      publicKey: pub,
      privateKey: priv.asHex(),
      // signer: x_signer
    });


    var { username, email, passwordOne,
      address, company, licenseNumber,
      licenseType, xplotLocation, yplotLocation,
      comments, isAdmin, isFarmer, isProcessor, isRegulator,
      isSeedProducer, publicKey, privateKey } = this.state;

    const roles = {};

    if (isAdmin) {
      roles[ROLES.ADMIN] = ROLES.ADMIN;
    }
    if (isFarmer) {
      roles[ROLES.FARMER] = ROLES.FARMER;
    }
    if (isProcessor) {
      roles[ROLES.PROCESSOR] = ROLES.PROCESSOR;
    }
    if (isRegulator) {
      roles[ROLES.REGULATOR] = ROLES.REGULATOR;
    }
    if (isSeedProducer) {
      roles[ROLES.SEEDPRODUCER] = ROLES.SEEDPRODUCER;
    }
    // const cbor = require('cbor')

    // const payload = {
    //   Verb: 'set',
    //   Name: 'foo',
    //   Value: 42
    // }

    // const payloadBytes = cbor.encode(payload)

    this.props.firebase
      .doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        // Create a user in your Firebase realtime database
        return this.props.firebase.user(authUser.user.uid).set({
          username,
          email,
          roles,
          address,
          company,
          licenseNumber,
          licenseType,
          xplotLocation,
          yplotLocation,
          comments,
          publicKey,
          privateKey,
          // signer
        });
      })
      .then(() => {
        return this.props.firebase.doSendEmailVerification();
      })
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.HOME);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    const {
      username,
      email,
      passwordOne,
      passwordTwo,
      address,
      company,
      licenseNumber,
      licenseType,
      xplotLocation,
      yplotLocation,
      comments,
      isAdmin,
      isFarmer,
      isProcessor,
      isRegulator,
      isSeedProducer,
      error,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      username === '' ||
      address === '' ||
      company === '' ||
      licenseNumber === '' ||
      licenseType === '' ||
      company === '' ||
      xplotLocation === '' ||
      yplotLocation === '';

    return (
      <form onSubmit={this.onSubmit} style={{ textAlign: 'center' }}>
        <TextField
          name="username"
          value={username}
          onChange={this.onChange}
          type="text"
          placeholder="Full Name"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="email"
          value={email}
          onChange={this.onChange}
          type="text"
          placeholder="Email Address"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="passwordOne"
          value={passwordOne}
          onChange={this.onChange}
          type="password"
          placeholder="Password"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="passwordTwo"
          value={passwordTwo}
          onChange={this.onChange}
          type="password"
          placeholder="Confirm Password"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="address"
          value={address}
          onChange={this.onChange}
          type="text"
          placeholder="Address"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="company"
          value={company}
          onChange={this.onChange}
          type="text"
          placeholder="Company"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <br></br>
        <h4>Hemp License Information</h4>
        <TextField
          name="licenseNumber"
          value={licenseNumber}
          onChange={this.onChange}
          type="text"
          placeholder="License Number"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="licenseType"
          value={licenseType}
          onChange={this.onChange}
          type="text"
          placeholder="License Type"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="xplotLocation"
          value={xplotLocation}
          onChange={this.onChange}
          type="text"
          placeholder="Plot Location (X)"
          style={{ paddingBottom: '10px' }}
        />
        <TextField
          name="yplotLocation"
          value={yplotLocation}
          onChange={this.onChange}
          type="text"
          placeholder="Plot Location (Y)"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <TextField
          name="comments"
          value={comments}
          onChange={this.onChange}
          type="text"
          placeholder="Comments"
          style={{ paddingBottom: '10px' }}
        />
        <br />
        <FormControlLabel
          control={<Checkbox 
            name="isAdmin"
            type="checkbox"
            checked={isAdmin}
            onChange={this.onChangeCheckbox}
            />}
            label="Admin" 
        />
        <FormControlLabel
          control={<Checkbox 
            name="isSeedProducer"
            type="checkbox"
            checked={isSeedProducer}
            onChange={this.onChangeCheckbox}
            />}
            label="Seed Producer" 
        />
        <FormControlLabel
          control={<Checkbox 
            name="isFarmer"
            type="checkbox"
            checked={isFarmer}
            onChange={this.onChangeCheckbox}
            />}
            label="Farmer" 
        />
        <FormControlLabel
          control={<Checkbox 
            name="isProcessor"
            type="checkbox"
            checked={isProcessor}
            onChange={this.onChangeCheckbox}
            />}
            label="Processor" 
        />
        <FormControlLabel
          control={<Checkbox 
            name="isRegulator"
            type="checkbox"
            checked={isRegulator}
            onChange={this.onChangeCheckbox}
            />}
            label="Regulator" 
        />
        <br />
        <Button disabled={isInvalid} type="submit">
          Sign Up
        </Button>

        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

const SignUpLink = () => (
  <p>
    Don't have an account? <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
  </p>
);

const SignUpForm = compose(
  withRouter,
  withFirebase,
)(SignUpFormBase);

export default SignUpPage;

export { SignUpForm, SignUpLink };
